
var TES = TES || {};

TES.Cookie = (function (w) {
    var base = window.location.origin || window.location.href;

    createCookie = function (name, value, expireIn) {
        if (expireIn) {
            var date = new Date();
            date.setTime(date.getTime() + (expireIn * 24 * 60 * 60 * 1000));

            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    };

    getCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    deleteCookie = function(name, path, domain) {
        createCookie(name, "", -1);
    };

    dropCookieAndRedirect = function (redirectTo, expireIn) {
        createCookie('tesJobAppCampaign', 't9', expireIn);
        w.location = base + '/' + redirectTo;
    };

    return {
        createCookie: createCookie,
        getCookie: getCookie,
        deleteCookie: deleteCookie,
        dropCookieAndRedirect: dropCookieAndRedirect
    };
})(window);
